import { useMutation, useQueryClient } from "@tanstack/react-query";
import { login, logout as apiLogout } from "../api/auth";

export function useLogin() {
    return useMutation({
        mutationFn: login
    });
}


export function useLogout() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: apiLogout,
        onSettled: () => {
            qc.clear();
        },
    });
}